import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const schema = yup.object().shape({
	fullName: yup
		.string()
		.matches(/^([^0-9]*)$/, "Full name should not contain numbers")
		.required("Full name is a required field"),
	subject: yup.string().required("Full name is a required field"),
	email: yup
		.string()
		.email("Email should have a correct format")
		.required("Email is a required field"),
	message: yup.string().required("Message is a required field"),
});

const ContactMe = () => {
	const [initialValue, setInitialValue] = useState({});

	console.log(setInitialValue);

	const form = useRef();

	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm({
		defaultValues: {
			fullName: initialValue.fullName,
			subject: initialValue.subject,
			email: initialValue.email,
			message: initialValue.message,
		},
		mode: "onBlur",
		resolver: yupResolver(schema),
	});

	const sendEmail = (e) => {
		emailjs
			.sendForm(
				"service_uctqxpi",
				"template_6nwqgq9",
				form.current,
				"user_A5i3X6hUVOd6bBIsbNTr0"
			)
			.then(
				(result) => {
					toast.success("Email has sent.");
				},
				(error) => {
					toast.error("Something went wrong!");
					console.log(error.text);
				}
			);
	};

	const onSubmit = (data, e) => {
		sendEmail(e);
		reset();
	};

	return (
		<>
			<div className="wrapper pt-24">
				<div className="flex flex-wrap justify-center">
					<div className="w-full md:w-8/12">
						<h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-center">
							Contact Me
						</h1>
						<form
							onSubmit={handleSubmit(onSubmit)}
							ref={form}
							noValidate
						>
							<input
								className={`form-input ${
									errors.fullName && "form-error"
								}`}
								type="text"
								placeholder="Full Name"
								name="fullName"
								{...register("fullName")}
							/>
							{errors?.fullName && (
								<span className="pl-1 text-red-500">
									{errors?.fullName?.message}
								</span>
							)}

							<input
								className={`form-input ${
									errors.email && "form-error"
								}`}
								type="email"
								placeholder="Email"
								name="email"
								{...register("email")}
							/>
							{errors?.email && (
								<span className="pl-1 text-red-500">
									{errors?.email?.message}
								</span>
							)}

							<input
								className={`form-input ${
									errors.subject && "form-error"
								}`}
								type="text"
								placeholder="Subject"
								name="subject"
								{...register("subject")}
							/>
							{errors?.subject && (
								<span className="pl-1 text-red-500">
									{errors?.subject?.message}
								</span>
							)}

							<textarea
								className={`form-input ${
									errors.message && "form-error"
								}`}
								name="message"
								placeholder="Write messege here..."
								rows="5"
								{...register("message")}
							/>
							{errors?.message && (
								<span className="pl-1 text-red-500">
									{errors?.message?.message}
								</span>
							)}

							<button
								className="mt-4 py-2 px-4 rounded font-semibold btn-primary w-full"
								type="submit"
							>
								Send Email
							</button>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default ContactMe;
